define('app/shared/nav/navController.js',[], function() {
	function navController($scope, $routeParams, $location) {
		$scope.isActive = function (viewLocation) {
			return viewLocation === $location.path();
		}
	}

  	navController.$inject=['$scope','$routeParams', '$location'];

  	return navController;
});
